import React from 'react';
import './NoProducts.css'

const LoginSignupContainer = () => {

  return (
    <div className='no-products'>
      <p>There are currently no products. Please check later to see if new products are added.</p>
    </div>
  );
};

export default LoginSignupContainer;